import { render, staticRenderFns } from "./cpjs.vue?vue&type=template&id=3062ec91&scoped=true&"
import script from "./cpjs.vue?vue&type=script&lang=js&"
export * from "./cpjs.vue?vue&type=script&lang=js&"
import style0 from "./cpjs.vue?vue&type=style&index=0&id=3062ec91&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3062ec91",
  null
  
)

export default component.exports